module.exports = __webpack_public_path__ + "img/10.f8401d9a.jpg";